import { Component, OnInit } from '@angular/core';
import { filter, map, mergeMap } from 'rxjs/operators';
import { IPolicy } from 'wz-types/pages-policies';
import { AlertService, PagesPoliciesService } from '~shared/services';


@Component({
  selector: 'wz-seller-agreement-page',
  templateUrl: './seller-agreement-page.component.html',
  styleUrls: ['./seller-agreement-page.component.scss']
})
export class SellerAgreementPageComponent implements OnInit {
  isLoading: boolean;
  isEdited: boolean;
  lastUpdatedDate: number;
  lastUpdatedByEmail: string;
  termsHtml: string;

  constructor(
    private pagesPoliciesSrv: PagesPoliciesService,
    private alertSrv: AlertService
  ) { }

  ngOnInit() {
    this.isLoading = true;
    this.pagesPoliciesSrv.getPolicy('sellerAgreement').pipe(
      map((policyDoc: IPolicy) => {
        if (!!policyDoc) {
          this.termsHtml = policyDoc.html;
          this.lastUpdatedDate = <any>policyDoc.lastUpdatedDate;
          this.lastUpdatedByEmail = policyDoc.lastUpdatedBy.email;
        }
        this.isLoading = false;
      })
    ).subscribe();
  }

  termsUpdated(newHtml): void {
    this.isEdited = true;
    this.termsHtml = newHtml;
  }

  saveChanges() {
    this.alertSrv.confirm('Submit changes?', 'All changes will go live on the site immediately.').pipe(
      filter((didConfirm: boolean) => didConfirm),
      mergeMap(() => this.pagesPoliciesSrv.savePolicy('sellerAgreement', this.termsHtml)),
      map(() => {
        this.isEdited = false;
        this.alertSrv.successToast('Seller agreement updated!');
        this.ngOnInit();
      })
    ).subscribe();
  }

}
